import { formatISO } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import { DateSearchbar } from '../../../components/DatebarSearch/DateSearchbar.component';
import { RangeFilterProps } from './filters.types';

export interface DateFilterProps extends RangeFilterProps<string> {
  valueFrom?: string;
  valueTo?: string;
}

export const DateFilter: React.FC<DateFilterProps> = ({
  fromValueName,
  toValueName,
  onChange,
  resetFilter,
  isActiveFilter,
  isTimePicker,
  valueFrom,
  valueTo,
}) => {
  const [, setDateFilter] = useState<string[]>([]);

  useEffect(() => {
    if (resetFilter) {
      setDateFilter([]);
    }
  }, [resetFilter]);

  const handleDateFilterChange = useCallback(
    (dateFrom?: Date, dateTo?: Date) => {
      if (dateFrom && dateTo) {
        const val = [formatISO(dateFrom).substring(0, 19), formatISO(dateTo).substring(0, 19)];
        setDateFilter(val);
        onChange(fromValueName, val[0]);
        onChange(toValueName, val[1]);
      } else {
        setDateFilter([]);
        onChange(fromValueName, []);
        onChange(toValueName, []);
      }
    },
    [onChange],
  );

  return (
    <DateSearchbar
      isActiveFilter={isActiveFilter}
      onChange={handleDateFilterChange}
      noBorder={true}
      removeFilter={handleDateFilterChange}
      isTimePicker={isTimePicker}
      valueFrom={valueFrom}
      valueTo={valueTo}
    />
  );
};
